import { DateTime } from 'luxon';
import { useMemo } from 'react';

import { StoreFieldsFragment } from '../../graphql';
import { getStoreHours } from '../../Store/utils/getStoreHours';
import { getStoreOpenStatus } from '../../Store/utils/getStoreOpenStatus';
import { DayNum } from '../../types';
import { getNow } from '../../utils/getNow';
import { userTimeZone } from '../../utils/userTimeZone';

export type HoursWarningProps = React.HTMLAttributes<HTMLDivElement> & {
	store: StoreFieldsFragment;
	now?: DateTime;
};

export const HoursWarning: React.FC<HoursWarningProps> = ({
	store,
	now = getNow()
}) => {
	const openStatus = useMemo(
		() => getStoreOpenStatus(store, now),
		[store, now]
	);
	const hours = useMemo(() => getStoreHours(store, now), [store, now]);
	const today: DayNum = useMemo(() => now.weekday as DayNum, [now]);

	const todayHours = useMemo(() => hours[today], [hours, today]);
	// const tomorrowHours = useMemo(() => hours[tomorrow], [hours, tomorrow]);

	let label: JSX.Element | null;

	switch (openStatus) {
		case 'CLOSING_SOON':
			label = (
				<span className="text-danger">
					Closing Soon
					{/* (
					{tomorrowHours?.close.tz(userTimeZone).fromNow()}) */}
				</span>
			);

			break;
		case 'NOT_OPEN_YET':
			label = (
				<span className="text-secondary">
					Opening Soon
					{/* s At{' '}
					{todayHours?.open.tz(userTimeZone).format('h:mm A')} */}
				</span>
			);

			break;
		case 'OPEN':
			label = <span className="text-success">Open Now</span>;

			break;
		case 'OPENING_SOON':
			label = (
				<span className="text-secondary">
					Opens {todayHours?.open.setZone(userTimeZone).toRelative()}
				</span>
			);

			break;
		case 'OPEN_TOMORROW':
			label = (
				<span className="text-danger">
					Opens Tomorrow
					{/* {' '}
					{tomorrowHours?.open
						.tz(userTimeZone)
						.format('ddd [at] h:mm A')} */}
				</span>
			);

			break;
		case 'NEVER':
		case 'CLOSED':
		default:
			label = <span className="text-danger">Closed</span>;

			break;
	}

	return (
		<div className="mb-2 font-weight-bold store-hours-warning">{label}</div>
	);
};
